// extracted by mini-css-extract-plugin
module.exports = {"wrapRow":"FormattedSupervisor_wrapRow__3WoWG"};